// extracted by mini-css-extract-plugin
export var entitlementsSubTabTabs = "entitlements-sub-tab__tabs_RymI9cghv8KYLv3GUkHf";
export var entitlementsSubTabTitle = "entitlements-sub-tab__title_IvJPirOl5NPrxWYSizx7";